/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPencilTriangleLeft: {
  name: 'pencil-triangle-left';
  data: string;
} = {
  name: 'pencil-triangle-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.586 5a2 2 0 0 1 2.828 0L19 7.586l-.707.707.707-.707a2 2 0 0 1 0 2.828l-8.545 8.545a2 2 0 0 1-1.193.574l-2.91.323a2 2 0 0 1-2.208-2.209l.323-2.909a2 2 0 0 1 .574-1.193l6.246-6.246.006-.006.006-.006L13.586 5Zm-7.13 9.96L12 9.413 14.586 12 9.04 17.545l-2.91.323.324-2.909ZM17.585 9 16 10.586 13.414 8 15 6.414 17.586 9ZM20 18.92a1 1 0 0 1-1.625.78l-2.399-1.92a1 1 0 0 1 0-1.56l2.4-1.92a1 1 0 0 1 1.624.78v3.84Z" fill="currentColor"/></svg>`,
};
